import * as React from "react";
import { Button } from "../Button/Button";
import ChevronBackIcon from "../../icons/ChevronBack";
import { cn } from "../../../helpers";
import styles from "./BackButton.module.scss";

export interface BackButtonProps {
    onClick: () => void;
    className?: string;
}

const BackButton = React.forwardRef<HTMLButtonElement, BackButtonProps>(
    ({ onClick, className }, ref) => {
        return (
            <Button
                onClick={onClick}
                variant="normal"
                className={cn(styles.backButton, className)}
                ref={ref}
            >
                <ChevronBackIcon />
            </Button>
        );
    }
);

BackButton.displayName = "BackButton";
export { BackButton };
